exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs[_v-41b125b1] {\n  margin-bottom: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-41b125b1&file=TabGroup.vue&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/TabGroup.vue
// module id = 207
// module chunks = 0